import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  GetNumberOfUnreadNotificationsResponse,
  GetRecentNotificationsResponse,
  NotificationDto,
  NotificationsRecentListParams
} from '@bannerflow/types.notification-service';
import { map, Observable } from 'rxjs';
import { NS_CONFIG_TOKEN } from '../notification.types';
import { buildUrl } from '../utils/http.utils';

@Injectable()
export class NotificationDataService {
  private httpClient = inject(HttpClient);
  private readonly config = inject(NS_CONFIG_TOKEN);

  loadMostRecentNotification(
    page = 1,
    itemsPerPage = 25
  ): Observable<GetRecentNotificationsResponse> {
    const baseUrl = `${this.config.apiUri}/notifications/recent`;
    const params: NotificationsRecentListParams = {
      page,
      itemsPerPage
    };

    const url = buildUrl(baseUrl, params);

    return this.httpClient.get<GetRecentNotificationsResponse>(url);
  }

  getNumberUnreadNotifications(): Observable<GetNumberOfUnreadNotificationsResponse> {
    const url = `${this.config.apiUri}/notifications/unread/count`;
    return this.httpClient.get<GetNumberOfUnreadNotificationsResponse>(url);
  }

  markAsRead(notification: NotificationDto): Observable<boolean> {
    const url = `${this.config.apiUri}/notifications/${notification.id}/mark-as-read`;
    return this.httpClient
      .patch<boolean>(url, undefined, { observe: 'response' })
      .pipe(map(response => response.ok));
  }

  markAllAsRead(): Observable<boolean> {
    const url = `${this.config.apiUri}/notifications/mark-all-as-read`;
    return this.httpClient
      .patch<boolean>(url, undefined, { observe: 'response' })
      .pipe(map(response => response.ok));
  }

  getNotificationById(notificationId: string): Observable<NotificationDto> {
    const url = `${this.config.apiUri}/notifications/${notificationId}`;

    return this.httpClient.get<NotificationDto>(url);
  }
}
